import styles from './Footer.module.css'

function Footer() {
    return (
        <footer className={styles.footer}>
            <p>
                Arthur Gehlen &copy; 2025
            </p>
        </footer>
    )
}

export default Footer